module.exports = __webpack_public_path__ + "img/radio.56725faf.png";